import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { PrelanderV59Page } from './ui/pages/PrelanderV59Page';
import { PrelanderV58Page } from './ui/pages/PrelanderV58Page';
import { PrelanderV57Page } from './ui/pages/PrelanderV57Page';
import { PrelanderV56Page } from './ui/pages/PrelanderV56Page';
import { PrelanderV53Page } from './ui/pages/PrelanderV53Page';
import { PrelanderV51Page } from './ui/pages/PrelanderV51Page';
import { PrelanderV50Page } from './ui/pages/PrelanderV50Page';
import { UpsellLettersPage } from './ui/pages/UpsellLettersPage';
import { UpsellLettersPageV2 } from './ui/pages/UpsellLettersPageV2';
import { UpsellLettersPageV3 } from './ui/pages/UpsellLettersPageV3';
import { getPurchaseData } from './lib/use-cases/get-purchase';
import { getFbclid } from './lib/shared/ad-helpers';
import { amplitudeTracker } from './lib/shared/amplitude-tracker';
import { setCustomHeightVariable } from './lib/shared/dimensions';
import { sentryLogger } from './lib/shared/sentry-logger';
import { growthBook } from './lib/shared/growthbook';
import config from './config';
import '@virtualstate/navigation/polyfill';
import './common.css';

sentryLogger.init(config.environment);

const PATH_NAMES = ['', '/v59', '/v58', '/v57', '/v56', '/v53', '/v51', '/v50'];

amplitudeTracker.init(config.amplitudeApiKey, config.amplitudeServerUrl);
amplitudeTracker.onSubscribe();

const growthBookInstance = growthBook.init(config.growthBookApiHost, config.growthBookClientKey);

growthBook.setUserAttributes();
growthBook.onSubscribe();

function App() {
    useEffect(() => {
        setCustomHeightVariable();
        window.addEventListener('resize', setCustomHeightVariable);
        growthBook.loadFeatures();

        if (PATH_NAMES.includes(window.location.pathname)) {
            const purchaseData = getPurchaseData();

            if (getFbclid(window.location.search) && purchaseData.subscriptionId) {
                window.location.replace(`${config.platformUrl}/dashboard`);
            }
        }
    }, []);

    const renderPage = () => {
        if (window.location.pathname === '/v59') {
            return <PrelanderV59Page initialPrelander='v59' />;
        }

        if (window.location.pathname === '/v58') {
            return <PrelanderV58Page initialPrelander='v58' />;
        }

        if (window.location.pathname === '/v57') {
            return <PrelanderV57Page initialPrelander='v57' />;
        }

        if (window.location.pathname === '/v56') {
            return <PrelanderV56Page initialPrelander='v56' />;
        }

        if (window.location.pathname === '/v53') {
            return <PrelanderV53Page initialPrelander='v53.2' />;
        }

        if (window.location.pathname === '/v51') {
            return <PrelanderV51Page initialPrelander='v51.2' />;
        }

        if (window.location.pathname === '/v50') {
            return <PrelanderV50Page initialPrelander='v50.2' />;
        }

        if (window.location.pathname === '/upsell/letters/v1') {
            return <UpsellLettersPage />;
        }

        if (window.location.pathname === '/upsell/letters/v2') {
            return <UpsellLettersPageV2 />;
        }

        if (window.location.pathname === '/upsell/letters/v3') {
            return <UpsellLettersPageV3 />;
        }

        if (window.location.pathname === '/') {
            return <PrelanderV50Page initialPrelander='v50.2' />;
        }

        return window.location.replace('/');
    };

    return (
        <GrowthBookProvider growthbook={growthBookInstance}>
            {renderPage()}
        </GrowthBookProvider>
    );
}

const root = createRoot(document.getElementById('root'));

root.render(<App />);
